<template>
    <div class="mainContainer pbottom50">
        <!-- <Banner/> -->
        <div class="title">
            <p><span style="font-weight: bold;">学员请注意：</span>缴费后在我的订单中点击”订单详情“自动开课</p>
            <p class="pointer" @click="enterOrderList">点我前往</p>
        </div>
        <Class/>
    </div>
</template>

<script>
// import Banner from "views/PcViews/Learn/Train/Banner"
import Class from "views/PcViews/Learn/Train/Class"
export default {
    components:{Class},
    methods:{
        enterOrderList(){
            this.$router.push('/pcViews/personal/order')
        }
    }
}
</script>

<style lang="less" scoped>
.title{
    padding: 20px;
    width: 1166px;
    margin: 40px auto;
    background-color: #098ef0;
    border-radius: 4px;color:#fff;
    font-size: 20px;
    display: flex;
    flex-direction: row;
    .pointer{
        margin-left: 40px;
        color: #e6a23c;
    }
}
</style>
